var render = function render(_c,_vm){return _c('hour-time-format',{attrs:{"type":_vm.props.row.hour_type}})
}
var staticRenderFns = []

export { render, staticRenderFns }